<form [formGroup]="form" class="cemento-facturacion-section" autocomplete="off">

  <!-- Sección: Datos de Facturación -->
  <p class="cemento-facturacion-section__notice">
    Ingresa los datos necesarios para la facturación
  </p>

  <input
    type="email"
    class="w-100 form-control cemento-facturacion-section__input"
    placeholder="Correo electrónico de facturación *"
    formControlName="email"
    [class.is-invalid]="form.get('email')?.touched && form.get('email')?.invalid" />
  @if (form.get('email')?.touched && form.get('email')?.invalid) {
    <p class="cemento-facturacion-section__error">Por favor ingrese un correo válido</p>
  }

  <input
    type="text"
    class="w-100 form-control cemento-facturacion-section__input"
    placeholder="Razón social / Nombre completo *"
    formControlName="name"
    [class.is-invalid]="form.get('name')?.touched && form.get('name')?.invalid" />
  <p class="cemento-facturacion-section__hint">
    Ingresa la razón social o tu nombre completo si eres persona natural.
  </p>

  <input
    type="text"
    class="w-100 form-control cemento-facturacion-section__input"
    placeholder="RUT a facturar *"
    formControlName="rut"
    (change)="checkRut()"
    [class.is-invalid]="form.get('rut')?.touched && form.get('rut')?.invalid" />
  @if (form.get('rut')?.touched && form.get('rut')?.invalid) {
    <p class="cemento-facturacion-section__error">Por favor ingrese un RUT válido</p>
  }

  <div class="cemento-facturacion-section__check-row">
    <input
      type="checkbox"
      id="sameDispatchAddress"
      class="cemento-facturacion-section__check"
      formControlName="sameDispatchAddress" />
    <label class="cemento-facturacion-section__check-label" for="sameDispatchAddress">
      Utilizar dirección de despacho como dirección de facturación
    </label>
  </div>

  <input
    type="text"
    class="w-100 form-control cemento-facturacion-section__input"
    placeholder="Dirección de facturación *"
    formControlName="addressDisplay"
    readonly
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    [class.is-invalid]="
      (form.get('address')?.touched && form.get('address')?.invalid) ||
      (form.get('addressDisplay')?.invalid ?? false)
    "
    [ngStyle]="{
      'background-color': form.controls.sameDispatchAddress.value ? '#e9ecef' : '#fff',
      cursor: form.controls.sameDispatchAddress.value ? 'default' : 'pointer'
    }"
    (click)="openAddressModal()"
    (keyup.enter)="$event.preventDefault()" />

  <!-- Sección: Datos de Contacto -->
  <p class="cemento-facturacion-section__section-title">Datos de Contacto</p>

  <input
    type="text"
    class="w-100 form-control cemento-facturacion-section__input"
    placeholder="Nombre *"
    formControlName="contactName"
    [attr.maxlength]="contactNameMaxLength"
    [class.is-invalid]="form.get('contactName')?.touched && form.get('contactName')?.invalid" />
  @if (form.get('contactName')?.touched && form.get('contactName')?.hasError('maxlength')) {
    <p class="cemento-facturacion-section__error">
      El nombre de contacto admite como máximo {{ contactNameMaxLength }} caracteres.
    </p>
  }

  <cbb-text-field-mask
    placeholder="Celular * — Ej: 9 1234 5678"
    mask="0 0000 0000"
    prefix="+56 "
    [value]="form.controls.contactPhone.value"
    [isInvalid]="contactPhoneShowError()"
    [readonly]="form.controls.contactPhone.disabled"
    (valueOnInput)="form.controls.contactPhone.setValue($event)"
    (valueOnBlur)="form.controls.contactPhone.markAsTouched()">
  </cbb-text-field-mask>
  @if (contactPhoneShowError()) {
    <p class="cemento-facturacion-section__error">Por favor ingrese un número de celular válido</p>
  } @else {
    <p class="cemento-facturacion-section__hint">
      Usaremos este número como contacto para coordinar el despacho.
    </p>
  }

  <textarea
    class="w-100 form-control cemento-facturacion-section__textarea"
    placeholder="Instrucciones de entrega (Opcional) — Ej: acceso a la obra, referencias, horarios, indicaciones para el conductor"
    formControlName="deliveryInstructions"
    [attr.maxlength]="deliveryInstructionsMaxLength"
    rows="3"
    [class.is-invalid]="
      form.get('deliveryInstructions')?.touched &&
      form.get('deliveryInstructions')?.hasError('maxlength')
    ">
  </textarea>
  @if (
    form.get('deliveryInstructions')?.touched &&
    form.get('deliveryInstructions')?.hasError('maxlength')
  ) {
    <p class="cemento-facturacion-section__error">
      Las instrucciones de entrega no pueden superar {{ deliveryInstructionsMaxLength }} caracteres.
    </p>
  }

  <!-- Términos y condiciones -->
  <div class="cemento-facturacion-section__check-row">
    <input
      type="checkbox"
      id="acceptTerms"
      class="cemento-facturacion-section__check"
      formControlName="acceptTerms"
      [class.is-invalid]="form.get('acceptTerms')?.touched && form.get('acceptTerms')?.invalid" />
    <span
      class="cemento-facturacion-section__terms-link"
      role="button"
      tabindex="0"
      (click)="openModal(content)"
      (keydown.enter)="openModal(content)"
      (keydown.space)="$event.preventDefault(); openModal(content)">
      Acepto los términos y condiciones
    </span>
  </div>

  <p class="cemento-facturacion-section__required-note">* Datos obligatorios</p>

</form>

<ng-template #addressModal let-modal>
  <div class="address-modal">
    <div class="address-modal__header">
      <p class="address-modal__title">Dirección de facturación</p>
      <button
        type="button"
        class="address-modal__close"
        aria-label="Cerrar"
        (click)="modal.dismiss()">
        &#x2715;
      </button>
    </div>

    <div class="address-modal__body" [formGroup]="formAddress">
      <div class="address-modal__row">
        <select
          class="address-modal__select"
          formControlName="region">
          <option value="" selected disabled>Región</option>
          <option *ngFor="let item of regionesComunas" value="{{ item.nombreRegion }}">
            {{ item.nombreRegion }}
          </option>
        </select>

        <select
          class="address-modal__select"
          formControlName="comuna">
          <option value="" selected disabled>Comuna</option>
          <option *ngFor="let item of comunaByRegion" value="{{ item }}">{{ item }}</option>
        </select>
      </div>

      <div class="address-modal__row">
        <input
          class="address-modal__input"
          type="text"
          placeholder="Calle"
          formControlName="street" />
        <input
          class="address-modal__input address-modal__input--short"
          type="text"
          placeholder="Número"
          formControlName="number" />
      </div>

      <button
        type="button"
        class="address-modal__btn"
        [disabled]="formAddress.invalid"
        (click)="guardarAddress()">
        Verificar dirección
      </button>
    </div>
  </div>
</ng-template>


<ng-template #content let-c="close" let-d="dismiss" class=" w-50">
  <div class="modal-header">
    <h4 class="modal-title text-uppercase">
      <img class="me-4" src="assets/img/logo.svg" alt="Cbb Store" [width]="50">
      Términos y Condiciones
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p><strong>Consideraciones Comerciales</strong></p>
    <p><strong>Despacho:</strong> El plazo de entrega será el que corresponda según la Política de Entrega de Cbb. Esta política define los plazos de entrega en función de la comuna, volumen y formato de entrega.</p>
    <p><strong>Condición de Pago:</strong> De acuerdo a lo establecido en la Ley n°21.131, cualquier condición de pago superior a 30 días, deberá estar amparada en un “Acuerdo Excepcional de Pago” debidamente firmado por ambas empresas y registrado en el Ministerio de Economía por parte del cliente.</p>
    <p><strong>Intereses y comisiones por atraso:</strong> De acuerdo a lo establecido en la Ley n°21.131 antes señalada, si no se verificara el pago dentro del plazo convenido y señalado en la respectiva factura, Cbb procederá a la liquidación de los intereses y comisión fija establecidos en dicha Ley, los cuales deberán ser cancelados por el cliente. Una vez recibido el pago, Cbb emitirá la(s) factura(s), y/o nota(s) de cobro correspondiente.</p>
    <p><strong>Pago:</strong> El no pago de cualquiera de las facturas emitidas en el plazo acordado facultará a Cementos Bío Bío S.A. a suspender el suministro de cemento solicitado.</p>
    <p><strong>Limitación de despacho:</strong> El suministro de cemento objeto de la presente oferta podrá ser modificado en su cantidad, o bien, suspendido en su totalidad por parte de Cbb, en el evento de ocurrir cualquier tipo de contingencia que limite o impida a Cbb la fabricación de dicho cemento.</p>
    <p><strong>Accesos:</strong> Es de responsabilidad del Cliente proveer de una ruta de acceso óptima para transporte de alto tonelaje, para asegurar una correcta entrega de los productos.</p>
    <p><strong>Transporte a destino:</strong> En el caso en que las partes acuerdan que Cbb realice el servicio de transporte a destino, y que el producto se entregue en el destino del cliente, Cbb realizará sus mejores esfuerzos para entregar en tiempo y forma el despacho producto de esta cotización, no pudiendo garantizar esta entrega en cantidad y plazo, pues el servicio se realizará con camiones de terceros.</p>
    <p><strong>Domingos y festivos:</strong> Los despachos solicitados para días domingos, feriados o festivos, deberán ser revisados caso a caso. El mayor costo asociado a estos despachos, serán informado al cliente, previo a la realización de éstos.</p>
    <p><strong>Impuestos extraordinarios:</strong> La inclusión de impuestos extraordinarios no está considerada en esta propuesta, por lo que, en caso de aplicarse al cemento, deberán agregarse al precio.</p>
    <p><strong>Precios:</strong> Los precios indicados en la presente cotización se han determinado teniendo especial consideración en la información proporcionada por el cliente sobre el Proyecto o Destino del Producto. Cualquier inexactitud o incumplimiento de dicha información referente a volumen de material requerido; dificultades de servicio etc. relacionada con la obra para lo cual se requieren los productos y servicios de Cbb, facultarán a esta última para revisar y corregir la cotización adjunta o en su defecto suspender el servicio y/o finalizar el suministro en forma inmediata.</p>
    <p><strong>Ensayos:</strong> En relación a las especificaciones técnicas del cemento, Cbb no entregará ensayos de autocontrol internos y solo se limitará a la entrega de los ensayos de caracterización según NCh 148 realizados por IDIEM, en cuanto estos sean emitidos.</p>
  </div>
</ng-template>
